import { NgModule } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { SharedHttpLoaderFactory, SharedModule } from '../common/shared.module';
import { HttpClient } from '@angular/common/http';
import { ArchwizardModule } from 'angular-archwizard';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PortalHeaderComponent } from './header/portal-header.component';
import { RouterModule } from '@angular/router';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: false,
    wheelPropagation: false
};

@NgModule({
    declarations: [
        PortalHeaderComponent
    ],
    imports: [
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: SharedHttpLoaderFactory,
                deps: [HttpClient]
            },
            isolate: false
        }),
        CommonModule,
        ArchwizardModule,
        NgbModule,
        FileUploadModule,
        SharedModule,
        FormsModule,
        NgxSpinnerModule,
        RouterModule
    ],
    exports: [
        TranslateModule,
        PortalHeaderComponent
    ],
    providers: [
    ],
})
export class PortalCommonModule { }
